import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LoadingScreen } from "@/components/sections/LoadingScreen";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Rooms } from "@/components/sections/Rooms";
import { Amenities } from "@/components/sections/Amenities";
import { Seasons } from "@/components/sections/Seasons";
import { Gallery } from "@/components/sections/Gallery";
import { Pricing } from "@/components/sections/Pricing";
import { Location } from "@/components/sections/Location";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
import { FloatingContact } from "@/components/sections/FloatingContact";

function App() {
  const [heroReady, setHeroReady] = useState(false);

  return (
    <div className="min-h-screen bg-[#F9F7F3] antialiased">
      <LoadingScreen onDone={() => setHeroReady(true)} />
      <Navbar />
      <main>
        <Hero animateIn={heroReady} />
        <About />
        <Rooms />
        <Amenities />
        <Seasons />
        <Gallery />
        <Pricing />
        <Location />
        <Contact />
      </main>
      <Footer />
      <FloatingContact />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
